import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  schoolTermListAllQuery,
  removeSchoolTermMutation,
} from '../../shared/queries/SchoolTerm';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';

const SchoolTerm = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const loadAllSchoolTerms = () => {
    const query = schoolTermListAllQuery();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.schoolTermListAll = res.schoolTermListAll.map((item) => ({
          ...item,
          formattedInitialDate: format(
            new Date(item.initialDate),
            'dd/MM/yyyy'
          ),
          formattedFinalDate: format(new Date(item.finalDate), 'dd/MM/yyyy'),
          translatedStatus: t(`school-term.${item.status}`),
        }));
        setData(res.schoolTermListAll);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    showLoading();
    const removeMutation = removeSchoolTermMutation(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        toggleModal();
        loadAllSchoolTerms();
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        hideLoading();
        toggleModal();
        loadAllSchoolTerms();
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ selectedDto: { status: 'C', id: 0 } });
    history.push('/minime/periodo-letivo/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    history.push(`/minime/periodo-letivo/mnt/${rowData.id}`);
  };

  useEffect(() => {
    loadAllSchoolTerms();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete-school-term')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    onRefreshClick={loadAllSchoolTerms}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    title={t('panels.periodo-letivo')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

SchoolTerm.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolTerm)
);
